import React from 'react';
import { FiUser, FiMapPin, FiStar, FiCheck, FiX } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { getTruckTypeLabel, formatTND, formatMoverRating, formatDistanceKm } from './utils/helpers';

const ResultsGrid = ({ 
  results, 
  onSelectMover, 
  selectedMovers = [],
  onToggleSelect 
}) => {
  if (results.length === 0) {
    return (
      <div className="col-span-full flex flex-col items-center justify-center py-12 text-gray-500">
        <p className="text-lg">Aucun résultat</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {results.map((r) => {
        const isSelected = selectedMovers.some(m => m.id === r.id);
        return (
          <motion.div
            key={r.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{ y: -4 }}
            onClick={() => onSelectMover(r)}
            className={`relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-5 border-2 cursor-pointer transition-all ${
              isSelected 
                ? 'border-amber-500 shadow-lg shadow-amber-500/20' 
                : 'border-gray-700 hover:border-gray-600'
            }`}
          >
            {/* Badge de sélection */}
            {isSelected && (
              <div className="absolute top-3 right-3 w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
                <FiCheck className="w-5 h-5 text-white" />
              </div>
            )}

            {/* Bouton sélection */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onToggleSelect(r);
              }}
              className={`absolute top-3 right-3 w-8 h-8 rounded-full border-2 flex items-center justify-center transition-colors ${
                isSelected
                  ? 'bg-amber-500 border-amber-500'
                  : 'bg-gray-700 border-gray-600 hover:border-amber-500'
              }`}
            >
              {isSelected ? (
                <FiCheck className="w-4 h-4 text-white" />
              ) : (
                <FiX className="w-4 h-4 text-gray-400" />
              )}
            </button>

            {/* Avatar */}
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center">
                <FiUser className="w-6 h-6 text-gray-900" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-white">
                  {r.firstName} {r.lastName}
                </h3>
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <FiStar className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  <span>{formatMoverRating(r.rating, r.reviewCount ?? r.reviews)}</span>
                </div>
              </div>
            </div>

            {/* Infos */}
            <div className="space-y-2 mb-4">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <FiMapPin className="w-4 h-4" />
                <span>{formatDistanceKm(r.distance)} km</span>
              </div>
              {r.truckType && (
                <div className="inline-block px-2 py-1 bg-amber-500/20 text-amber-300 rounded-lg text-xs">
                  {getTruckTypeLabel(r.truckType)}
                </div>
              )}
            </div>

            {/* Prix */}
            <div className="pt-4 border-t border-gray-700">
              <div className="text-2xl font-bold text-amber-400">
                {formatTND(r.price || 0)}
              </div>
              <div className="text-xs text-gray-400 mt-1">Estimation</div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default ResultsGrid;





